module.exports = __webpack_public_path__ + "static/media/manage_accounts_black.5703a5b0.svg";